export enum AppErrorsStatusCodes {
  MISSING_PROJECT_ID_ENV = 'MISSING_PROJECT_ID_ENV',
  MISSING_API_URL_ENV = 'MISSING_API_URL_ENV',
  NO_ORDER_ID_IN_URL = 'NO_ORDER_ID_IN_URL',
  NO_PATHNAME = 'NO_PATHNAME',
  MISSING_PATHNAME_HEADER = 'MISSING_PATHNAME_HEADER',
  MISSING_ORDER_ID_FROM_ORDER = 'MISSING_ORDER_ID_FROM_ORDER',
  INVALID_ORDER_DATA = 'INVALID_ORDER_DATA',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  UNKNOWN_REQUEST_ERROR = 'UNKNOWN_REQUEST_ERROR',
}

export enum ApiErrorPrefixes {
  ORDER = 'ORDER',
  RECEIPT_STATE = 'RECEIPT_STATE',
  RECEIPT_UPLOAD = 'RECEIPT_UPLOAD',
  DEPOSIT_CONFIRMATION = 'DEPOSIT_CONFIRMATION',
  USER_IP_SENDING = 'USER_IP_SENDING',
  FINGERPRINT_SENDING = 'FINGERPRINT_SENDING',
  UPLOAD_CANCELLATION = 'UPLOAD_CANCELLATION',
  RETRY_REQUISITES = 'RETRY_REQUISITES',
}

export interface AppErrorState {
  errorCode: string;
  showErrorPage: boolean;
  errorRedirectUrl?: string | null;
}
